import axios from '@axios'

export default {
  namespaced: true,
  actions: {
    getLinkedOptions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('userGetLinked', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getItemsLinkedTo(ctx,queryParams){
      return new Promise((resolve, reject) => {
        axios.get('links', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
  },

 
  }
  
}
